import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FormControl, InputLabel, Select, type SelectProps } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

import { baseInputStyles, borderBlur } from '../styles'

type SelectInfoStyledProps = SelectProps & {
  disabled?: boolean
}

interface LabelWrapperProps {
  disabled?: boolean
}

export const FormControlStyled = styled(FormControl)`
  .MuiSelect-select {
    padding: ${newTheme.spacing.xs} ${newTheme.spacing.md};
  }
  .MuiFormLabel-root,
  .Mui-error,
  .Mui-require {
    color: ${newTheme.colors.neutral.high};
  }

  .MuiOutlinedInput-root.MuiInputBase-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.Mui-error {
    fieldset {
      border: ${newTheme.shapes.borderWidth.thin} ${newTheme.colors.alert.danger.main};
    }
  }
`

export const SelectInfoStyled = styled(Select)<SelectInfoStyledProps>`
  ${baseInputStyles};
  font-size: ${newTheme.typography.sizes.xs};
  padding: ${newTheme.spacing.sm};
  background-color: ${newTheme.colors.neutral.white};
  padding: 0;
  cursor: pointer;

  // MUI keeps the focus class after blur, so this CSS simulates the unfocused state.
  :focus-within {
    ${borderBlur}
  }

  em {
    font-style: normal;
    -webkit-text-fill-color: ${newTheme.colors.neutral.mediumhover};
  }

  svg {
    color: ${newTheme.colors.primary.main};
  }

  div {
    display: flex;
    align-items: center;
  }

  .MuiSelect-select span {
    width: 100%;
    display: flex;
    overflow: hidden;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({ disabled }) =>
      disabled &&
      css`
        -webkit-text-fill-color: ${newTheme.colors.neutral.mediumhover};
      `}
  }

  #mui-component-select-address {
    padding-right: 0;
    margin-right: ${newTheme.spacing['2xm']};
  }
`

export const LabelInfosStyled = styled(InputLabel)`
  margin: 0;
  z-index: 0;
  cursor: inherit;
  color: ${newTheme.colors.neutral.high};
  font-size: ${newTheme.typography.sizes['2xs']};
  font-family: ${newTheme.typography.family.bold};
  font-weight: ${newTheme.typography.weight.lg};
  overflow: initial;
  position: relative;
  -webkit-transform: initial;
  transform: initial;

  .MuiInputLabel-asterisk {
    color: ${newTheme.colors.secondary};
  }
`

export const LabelWrapper = styled.div<LabelWrapperProps>`
  display: flex;
  align-items: center;
`

export const SearchInputContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  border: 1px solid ${newTheme.colors.neutral.mediumhover};
  border-radius: ${newTheme.shapes.borderRadius.sm};
  gap: ${newTheme.spacing.xs};
  padding: 0 ${newTheme.spacing.sm};
  cursor: text;

  :hover {
    background: transparent;
    border: 1px solid ${newTheme.colors.neutral.medium};
  }

  :focus-within {
    border: 1px solid ${newTheme.colors.primary.main};
  }

  input {
    display: flex;
    border: none;
    outline: none;
    width: 100%;
    font-size: ${newTheme.typography.sizes.xs};
    color: ${newTheme.colors.neutral.high};
    font-family: ${newTheme.typography.family.primary};

    ::placeholder {
      color: ${newTheme.colors.neutral.lighthover};
    }
  }
`
